export default __webpack_public_path__ + "static/media/link-white.5f585a52.svg";